document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('fitGuideModal');
  const btn = document.getElementById('openFitGuide');
  const closeBtn = document.getElementById('closeFitGuide');
  const overlay = document.getElementById('fitGuideOverlay');
  const toggle = document.getElementById('unitToggler');
  const dataCells = document.querySelectorAll('.fit-data-table [data-inch]');

  if (!modal || !btn) return;

  // THE FIX: Move the modal to the very root of the document.
  // This prevents Shopify headers from overlapping it.
  document.body.appendChild(modal);

  // 1. Open Modal
  btn.addEventListener('click', () => {
    modal.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; 
  });

  // 2. Close Modal Functions
  const closeModal = () => {
    modal.classList.remove('is-visible');
    document.body.style.overflow = '';
  };
  
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  // 3. Unit Conversion Logic
  if (toggle) {
    toggle.addEventListener('change', (e) => {
      const isCm = e.target.checked;

      dataCells.forEach(cell => {
        const inchValue = parseFloat(cell.getAttribute('data-inch'));
        const originalText = cell.getAttribute('data-inch-text');
        
        if (isCm) {
          const cmValue = (inchValue * 2.54).toFixed(1);
          cell.textContent = cmValue.endsWith('.0') ? cmValue.slice(0, -2) : cmValue;
        } else {
          cell.textContent = originalText;
        }
      });
    });
  }
});